<div class="flex" data-testid="menu-container">
    @for (page of navMenu.pages; track page) {
        <button mat-button type="button" [routerLink]="page.link" data-testid="main-page-button">
            <mat-icon [matTooltip]="page.name">{{page.icon }}</mat-icon>
            <span>{{page.name}}</span>
        </button>
    }

    <button mat-button type="button" [matMenuTriggerFor]="menu" data-testid="directory-button">
        <mat-icon [matTooltip]="navMenu.directory.name">keyboard_arrow_down</mat-icon>
        <span>{{navMenu.directory.name}}</span>
    </button>
    <mat-menu #menu="matMenu">
        @for (link of navMenu.directory.links; track link.name) {
            @if (!link['hide']) {
                <button mat-menu-item [routerLink]="link.link" >
                    <mat-icon [matTooltip]="link.name">{{ link.icon }}</mat-icon>
                    <span data-testid="directory-item-span">{{ link.name }}</span>
                </button>
            }
        }
    </mat-menu>

    @if (isAuth) {
        <button mat-button type="button" (click)="logout()" data-testid="exit-to-app-button">
            <mat-icon [matTooltip]="'Выход'">exit_to_app</mat-icon>
        </button>
    }

</div>
